import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {User} from "../api/Model";
import {useGoogleLogin} from "@react-oauth/google";
import axios from "axios";


export interface AuthState {
    token: string | null;
    user: User | null;
    isAuthenticated: boolean;
    login: (token: string, user: User) => void;
    logout: () => void;
}

export function useLoginClickHandler(authStore: AuthState): () => void {
    return useGoogleLogin({
        onSuccess: async (codeResponse) => {
            // Get the access_token from Google
            const googleAccessToken = codeResponse.access_token;

            try {
                // Send the Google access_token to your backend
                const response = await axios.post('/auth/login', { googleAccessToken });

                // Save the JWT token and user in the auth store
                const { token, user } = response.data;
                authStore.login(token, user);
            } catch (error) {
                console.error('Login failed:', error);
            }
        },
        flow: 'implicit'
    })
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            token: null,
            user: null,
            isAuthenticated: false,
            login: (token, user) => set({token, user, isAuthenticated: true}),
            logout: () => set({token: null, user: null, isAuthenticated: false}),
        }),
        {
            name: 'auth-storage',
            version: 2,
        }
    )
);